import { render, staticRenderFns } from "./DealNoteModal.vue?vue&type=template&id=23a05348&scoped=true&"
import script from "./DealNoteModal.vue?vue&type=script&lang=js&"
export * from "./DealNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a05348",
  null
  
)

export default component.exports